import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

/**
 * Shared OAuth-redirect receiver for the Google Ads interactive-connect flow
 * (`GOOGLE_ADS_OAUTH_CALLBACK_PATH`). Google redirects here with `code` +
 * `state` (`state` is the `connectionId` from step 1); which UI surface
 * started the flow (onboarding vs. the Integrations connections page) is
 * recovered from `sessionStorage`, not the URL — see
 * `google-ads-oauth.ts`.
 */
const GoogleAdsOAuthCallbackPage = lazy(
  () => import('~/features/onboarding/pages/google-ads-oauth-callback-page'),
);

const searchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
});

function GoogleAdsOAuthCallbackRouteComponent() {
  const { code, state } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <GoogleAdsOAuthCallbackPage code={code} state={state} />
    </Suspense>
  );
}

export const Route = createFileRoute('/_authenticated/_tenant/oauth/google-ads/callback')({
  validateSearch: searchSchema,
  component: GoogleAdsOAuthCallbackRouteComponent,
});
